import { BranchingQueryDefinition, classDerivedDeviceEnabledTypes, edgeTypeMatrix } from '@iotv/datamodel';
import { AdjacentType, getCardinality } from '@iotv/iotv-v3-types';
const debug = process.env.REACT_APP_DEBUG && false;
/** Turns an adjacent filter into equivalent branching query definition */
export const getBranchingQueryDefFromAdjacentFilter = (adjacentFilter, id) => {
    return new BranchingQueryDefinition({
        id: id ?? `${adjacentFilter.sourceObjectType}_${adjacentFilter.adjacentType}_${adjacentFilter.objectType}`,
        path: [
            {
                objectTypeId: adjacentFilter.objectType,
                adjacencyType: adjacentFilter.adjacentType,
                edgeTypeId: adjacentFilter.edgeFilter?.edgeTypeId,
                edgeAttributeFilters: adjacentFilter.edgeFilter?.edgeAttributeFilters,
                nodeFilters: adjacentFilter.filterConfig,
            },
        ],
    });
};
const getEdgeTypeDefinition = ({ fromObjectTypeId, toObjectTypeId, edgeTypeId, adjacentType }) => {
    let edgeTypeDefinition = undefined;
    switch (adjacentType) {
        case AdjacentType.CHILD:
            edgeTypeDefinition = edgeTypeMatrix[fromObjectTypeId]?.[toObjectTypeId]?.[edgeTypeId];
            break;
        case AdjacentType.PARENT:
            edgeTypeDefinition = edgeTypeMatrix[toObjectTypeId]?.[fromObjectTypeId]?.[edgeTypeId];
            break;
        default: {
        }
    }
    return edgeTypeDefinition;
};
export const getCardinalityFromListerlizerContext = ({ matchedPrimary, adjacentType, otherType, edgeTypeId }) => {
    let cardinality = undefined;
    if (matchedPrimary) {
        if (edgeTypeId) {
            const edgeTypeDefinition = getEdgeTypeDefinition({
                fromObjectTypeId: matchedPrimary.type,
                toObjectTypeId: otherType,
                adjacentType,
                edgeTypeId,
            });
            switch (adjacentType) {
                case AdjacentType.CHILD:
                    cardinality = getCardinality(edgeTypeDefinition?.cardinality?.out ?? null);
                    break;
                case AdjacentType.PARENT:
                    const enumKeys = Object.keys(classDerivedDeviceEnabledTypes);
                    if (enumKeys.includes(matchedPrimary.supportedType)) {
                        cardinality = undefined;
                        break;
                    }
                    else {
                        cardinality = getCardinality(edgeTypeDefinition?.cardinality?.in ?? null);
                        break;
                    }
                default: {
                }
            }
        }
        else {
            debug && console.log(`WARN: no edgeTypeId provided from ${matchedPrimary.type} to ${otherType} with ${adjacentType}`);
        }
    }
    else {
        debug && console.log(`WARN: no matchedPrimary provided for edge to ${otherType} with ${adjacentType} and edgeTypeId ${edgeTypeId}`);
    }
    return cardinality;
};
